import React, { useContext } from 'react';
import { initialTimeState } from '../ducks/timeDuck';

const TimeContext = React.createContext({
  state: initialTimeState,
  dispatch: null,
});

export const useTimeContext = () => useContext(TimeContext);

export const useTimeSelector = (selector, ...params) => {
  // we have both state managed by the reducer, and read only props we pass around using context
  const { state, props } = useTimeContext();
  return selector({
    state,
    props,
  }, ...params);
};

export const useTimeDispatch = () => {
  const { dispatch } = useTimeContext();
  return dispatch;
};

export default TimeContext;
